export default function initAnimations() {
    animations('.fadeInUp', 'js-visible', .1)
    animations('.fadeInLeft', 'js-visible', .1)
    animations(".sliceTop", "animate", 0.3)

    function animations(targets, animationClass, delayInt) {
        const observeParams = {
            rootMargin: "0px",
            threshold: 0.45,
        }

        if (window.matchMedia("(max-width: 768px)").matches) {
            observeParams.threshold = 0.35
        }

        const animateTargets = document.querySelectorAll(targets)
        // console.log('animate-target', animateTargets)

        if (animateTargets) {
            const observerCallback = (entries, observer) => {
                let delay = 0.25
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.setAttribute("style", `transition-delay: ${delay}s;`)
                        delay = delay + delayInt
                        entry.target.classList.add(animationClass)
                        
                    }
                })
            }
            const animateObserver = new IntersectionObserver(observerCallback, observeParams)

            animateTargets.forEach((target) => {
                animateObserver.observe(target)
            })
        }
    }
}
